export default function translatePolygonCoordinates(
  polygons: google.maps.LatLngLiteral[],
): number[][] {
  const coordinates = polygons.map(elem => [elem.lng, elem.lat]);
  // MongoDB require the loop to be closed with the initial value
  return [...coordinates, coordinates[0]];
}
